import http from "@/http-common";
import {
    USER_DETAIL,
    USER_PAYMENTS,
    CHANGE_PASSWORD_PROFILE,
    STARE_AND_CITIES_LIST,
    CANCEL_USER_SUBSCRIPTION,
    PARAMS_FOR_PAYMENT,
    UPDATE_USER,
    RESEND_EMAIL,
    CHANGE_CREDIT_CARD,
    SUBSCRIPTION_LIMITS,
    CHANGE_EMAIL
} from "@/api/Constants";
import Api from "@/api/methods/Api";
import { VENDOR_INVOICES } from "../Constants";

class ApiUsersProfile extends Api {
    getUserDetails(token) {
        return http.get(USER_DETAIL, this.headers(token));
    }

    updateUserDetails(data, token) {
        return http.post(UPDATE_USER, data, this.headers(token));
    }

    resendEmail(token) {
        return http.post(RESEND_EMAIL, this.headers(token));
    }

    changeEmail(data, token) {
        return http.post(CHANGE_EMAIL, data, this.headers(token));
    }

    stripeKey(token) {
        return http.get(PARAMS_FOR_PAYMENT, this.headers(token));
    }

    getUserPayments(token) {
        return http.get(USER_PAYMENTS, this.headers(token));
    }

    getVendorInvoices(token) {
        return http.get(VENDOR_INVOICES, this.headers(token));
    }

    cancelSubscription(token) {
        return http.get(CANCEL_USER_SUBSCRIPTION, this.headers(token));
    }

    getCityState(token, zipCode) {
        return http.get(STARE_AND_CITIES_LIST + zipCode, this.headers(token));
    }

    changePassword(_password, token) {
        return http.post(
            CHANGE_PASSWORD_PROFILE,
            {
                password: _password,
            },
            this.headers(token)
        );
    }

    changeCreditCard(data) {
        return http.post("api/creditCardChange", data);
    }

    deleteDefaultPaymentMethod() {
        return http.post("api/deleteDefaultPaymentMethod");
    }

    setUserParameterSetForUser(token, data) {
        return http.post("api/setUserParameterSetForUser", data, this.headers(token));
    }

    getAllParametersForGroup(token) {
        return http.get("api/getAllParametersForGroup", this.headers(token));
    }

    setUserGroupParameters(data) {
        return http.post("api/setUserGroupParameters", data);
    }

    saveInvestorProfile(data) {
        return http.post("/api/saveInvestorProfile", data);
    }

    getInvestorProfileCustom() {
        return http.get("/api/getInvestorProfileCustom");
    }

    getUserInvestorProfileCustom(userId) {
        return http.get("/api/getUserInvestorProfileCustom/" + userId);
    }

    saveInvestorProfileCustom(data) {
        return http.post("/api/saveInvestorProfileCustom", data);
    }

    getSubscriptionLimits (token) {
        return http.get(SUBSCRIPTION_LIMITS, this.headers(token));
    }

}

export default new ApiUsersProfile();
